import styles from './DisplayTableMobilePending.module.css';

export const DisplayTableMobilePending = () => {
    return (
        <table
            className={styles.displayTableMobile}
            data-testid="loan-builder-table-pending"
        >
            <tbody>
                <tr>
                    <th className={styles.tableHeader}>
                        <div className={styles.smallPendingItem} />
                    </th>
                    <th className={styles.tableHeader}>
                        <div className={styles.pendingItem} />
                    </th>
                </tr>
                <tr>
                    <td className={styles.tableData}>
                        <div className={styles.smallPendingItem} />
                    </td>
                    <td className={styles.tableData}>
                        <div className={styles.smallPendingItem} />
                    </td>
                </tr>
                <tr>
                    <td className={styles.tableData}>
                        <div className={styles.smallPendingItem} />
                    </td>
                    <td className={styles.tableData}>
                        <div className={styles.smallPendingItem} />
                    </td>
                </tr>
                <tr>
                    <td className={styles.tableData}>
                        <div className={styles.smallPendingItem} />
                    </td>
                    <td className={styles.tableData}>
                        <div className={styles.smallPendingItem} />
                    </td>
                </tr>
                <tr>
                    <td className={styles.tableData}>
                        <div className={styles.smallPendingItem} />
                    </td>
                    <td className={styles.tableData}>
                        <div className={styles.smallPendingItem} />
                    </td>
                </tr>
                <tr>
                    <td className={styles.tableFooterRadioBtn}>
                        <input
                            type="radio"
                            disabled={true}
                            className={styles.radioBtn}
                        />
                        <div className={styles.smallPendingItem} />
                    </td>
                    <td className={styles.tableFooterRadioBtn}>
                        <input
                            type="radio"
                            disabled={true}
                            className={styles.radioBtn}
                        />
                        <div className={styles.smallPendingItem} />
                    </td>
                </tr>
            </tbody>
        </table>
    );
};
